import { cn } from "@/lib/utils";
import type { ElementType, ReactNode } from "react";

const PANE_CONTENT_FADE_MS = 320;

export const PaneContent = ({
  as: Surface,
  children,
  ariaLabel,
  className,
  contentClassName,
  width,
  isVisible,
}: {
  as: ElementType;
  children: ReactNode;
  ariaLabel?: string;
  className?: string;
  contentClassName?: string;
  width?: number | string;
  isVisible: boolean;
}) => (
  <Surface
    aria-label={ariaLabel}
    style={width == null ? undefined : { width }}
    className={cn(
      "relative flex h-full min-w-0 flex-col overflow-hidden transition-[background-color,border-color,color] duration-300 ease-in-out",
      className
    )}
  >
    <div
      className={cn(
        "min-h-0 flex-1 transition-opacity ease-out",
        isVisible ? "opacity-100" : "opacity-0",
        contentClassName
      )}
      style={{ transitionDuration: `${PANE_CONTENT_FADE_MS}ms` }}
    >
      {children}
    </div>
  </Surface>
);
